import { AutoFixHigh, Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";
import { themeColors } from "Global/JsxThemeColor/JsxThemeColor";
import React from "react";
import { ConvertToEnglish } from "utils/ConvertToEnglish";

const useLogic = (props) => {
  const [password, setPassword] = React.useState(false);
  const inputValueRef = React.useRef("");
  const [forceRender, setForceRender] = React.useState(false);
  // Set the initial input value from the ref
  const initialValue = ConvertToEnglish(inputValueRef.current);

  React.useEffect(() => {
    if (props?.clearText) {
      // Clear the input value when clearText becomes true
      inputValueRef.current = "";
      props?.onChange && props?.onChange(""); // Optionally, you can also call the onChange callback
      setForceRender();
    }
  }, [props?.clearText]);

  const onChangeFn = (event) => {
    props?.CustomOnChange && props?.CustomOnChange(event);
    const englishValue = ConvertToEnglish(event.target.value);
    inputValueRef.current = englishValue;
    props?.onChange && props?.onChange(englishValue);
  };
  const InputAdornmentElement = (
    <InputAdornment position="end">
      {props?.onlyIcon ? (
        props?.onlyIcon
      ) : props?.isPassword ? (
        <IconButton
          color="colorPrimer"
          onClick={() => setPassword((prev) => !prev)}
        >
          {!password ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      ) : props?.icon ? (
        <IconButton
          sx={{
            color: `${themeColors.ColorPrimary} !important`,
          }}
          onClick={() => props?.iconFn(inputValueRef.current, props?.onChange)}
        >
          {props?.icon}
        </IconButton>
      ) : props?.enableSuggest ? (
        <IconButton
          sx={{
            "& svg": {
              fill: `${themeColors.ColorPrimary} !important`,
            },
          }}
          onClick={() => {
            if (props?.enableSuggest instanceof Array) {
              // props.setOpenSuggestBackdrop(true);
            }
          }}
        >
          <AutoFixHigh color="primary" />
        </IconButton>
      ) : null}
    </InputAdornment>
  );
  return [
    InputAdornmentElement,
    forceRender,
    initialValue,
    onChangeFn,
    password,
  ];
};

export default useLogic;
